<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto px-2 position-relative">
    <blocking-loader-overlay
      :show="loading_entries"
      :message="page_loading_message"
      :detail="page_loading_detail"
    />
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-1">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-1">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-white opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Home</span>
              <span>/</span>
              <span>Audit Log</span>
            </div>
            <h1 class="entity-page-title text-white lh-sm mb-1">System audit log</h1>
            
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-0">
        <section class="row g-2 align-items-center mt-1">
          <div class="col-12 col-xl-10">
            <div class="d-flex flex-column flex-lg-row align-items-lg-center gap-2 pb-2">
              <input
                v-model="search_text"
                type="text"
                class="form-control entity-binding-control audit-log-search-control"
                placeholder="Search events... (actor, case, action)"
              >
              <select v-model="selected_actor" class="form-select entity-binding-control audit-log-filter-control">
                <option v-for="actor in actor_filters" :key="actor.value" :value="actor.value">{{ actor.label }}</option>
              </select>
              <select v-model="selected_event" class="form-select entity-binding-control audit-log-filter-control audit-log-filter-control-event">
                <option v-for="event in event_filters" :key="event" :value="event">{{ event }}</option>
              </select>
              <select v-model="selected_status" class="form-select entity-binding-control audit-log-filter-control audit-log-filter-control-status">
                <option v-for="status in status_filters" :key="status" :value="status">{{ status }}</option>
              </select>
              <select v-model="selected_range" class="form-select entity-binding-control audit-log-filter-control audit-log-filter-control-range">
                <option v-for="range in range_filters" :key="range" :value="range">{{ range }}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl-2">
            <div class="d-flex justify-content-xl-end gap-2 pb-2">
              <button
                type="button"
                class="btn btn-light btn-sm rounded-small border entity-audit-btn px-3"
                :disabled="!filtered_entries.length"
                @click="export_excel"
              >
                Export Excel
              </button>
              <button
                type="button"
                class="btn btn-light btn-sm rounded-small border entity-audit-btn px-3"
                :disabled="!filtered_entries.length"
                @click="export_pdf"
              >
                Export PDF
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>

    <section class="row g-0 mt-2">
      <div class="col-12 p-0 m-0">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border-0 shadow-sm p-0 h-100 mt-0 overflow-hidden">
          <div class="table-responsive">
            <table class="table align-middle mb-0">
              <thead>
                <tr class="entity-table-head text-uppercase secondary-color">
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Time</th>
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Actor</th>
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Status</th>
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Action</th>
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Case / Target</th>
                  <th class="fw-semibold border-0 bg-transparent px-3 py-3 fs-6">Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="entry in paginated_entries" :key="entry.id">
                  <td class="px-3 py-3">
                    <div class="small text-dark fw-semibold">{{ entry.time }}</div>
                  </td>
                  <td class="px-3 py-3">
                    <div class="small text-dark fw-semibold">{{ entry.actor }}</div>
                    <div v-if="entry.actor_role || entry.actor_email" class="text-secondary text-xs mt-1">
                      {{ entry.actor_role || entry.actor_email }}
                    </div>
                  </td>
                  <td class="px-3 py-3">
                    <span class="badge rounded-pill fw-normal" :class="entry.status_badge_class">
                      {{ entry.status || 'No status' }}
                    </span>
                    <div class="text-secondary text-xs mt-2">{{ entry.source }}</div>
                  </td>
                  <td class="px-3 py-3">
                    <span class="badge rounded-pill fw-normal" :class="entry.action_badge_class">
                      {{ entry.action_label }}
                    </span>
                    <div class="small text-secondary mt-2">{{ entry.event_key }}</div>
                  </td>
                  <td class="px-3 py-3">
                    <div class="small text-dark fw-semibold">{{ entry.target }}</div>
                    <router-link
                      v-if="entry.case_route"
                      :to="entry.case_route"
                      class="btn btn-sm btn-light rounded-small border mt-2 px-2 py-1 text-xs"
                    >
                      Open case
                    </router-link>
                  </td>
                  <td class="px-3 py-3">
                    <div class="small text-dark">{{ entry.diff || '-' }}</div>
                  </td>
                </tr>
                <tr v-if="entries_error">
                  <td colspan="6" class="px-4 py-4 text-center text-secondary small">{{ entries_error }}</td>
                </tr>
                <tr v-else-if="!loading_entries && !filtered_entries.length">
                  <td colspan="6" class="px-4 py-4 text-center text-secondary small">No audit entries match this filter.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="!loading_entries && filtered_entries.length"
      class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3"
    >
      <div class="text-secondary text-xs">
        {{ pagination_summary }}
      </div>

      <nav aria-label="Audit log pagination">
        <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
          <button
            type="button"
            class="btn btn-sm btn-light border-0 rounded-0 px-2"
            @click="previous_page"
            :disabled="!can_go_previous"
            aria-label="Previous page"
          >
            <i class="bi bi-chevron-left"></i>
          </button>

          <button
            v-for="page in visible_page_numbers"
            :key="page"
            type="button"
            class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
            :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
            @click="set_page(page)"
          >
            {{ page }}
          </button>

          <button
            type="button"
            class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
            @click="next_page"
            :disabled="!can_go_next"
            aria-label="Next page"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </nav>
    </section>
  </div>
</div>
